import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TemplateObject } from './interfaces';


@Injectable({
    providedIn: 'root',
})
export class PopupTemplateContainerService {
    templates$ = new BehaviorSubject<TemplateObject<any>[]>([]);

    addTemplate<TemplateData>(template: TemplateObject<TemplateData>) {
        this.templates$.next([
            ...this.templates$.value.filter(
                (currentTemplate) => !isTemplatesEq(currentTemplate, template)
            ),
            {
                ...template
            },
        ]);
    }

    removeTemplate(template: Pick<TemplateObject, 'identifier' | 'type'>) {
        const isTemplateAlreadyExist =
            this.isTemplateExist(template);
        if (isTemplateAlreadyExist) {
            this.templates$.next(
                this.templates$.value.filter(
                    (currentTemplate) =>
                        !isTemplatesEq(currentTemplate, template)
                )
            );
        }
    }

    private isTemplateExist(
        template: Pick<TemplateObject, 'identifier' | 'type'>
    ) {
        const currentTemplates = this.templates$.value;
        return currentTemplates.some((currentTemplate) =>
            isTemplatesEq(currentTemplate, template)
        );
    }
}

const isTemplatesEq = (template1: Pick<TemplateObject, 'identifier' | 'type'>, template2: Pick<TemplateObject, 'identifier' | 'type'>) =>
    template1.type === template2.type &&
    template1.identifier === template2.identifier;
